import React, { useState } from "react";
import { isEmpty } from "lodash";
import './AccordionItem.css';
import Icon from "../../Icons/Icon";
import classNames from "classnames";
import { Collapse } from "reactstrap";
import { useHistory } from "react-router-dom";

const AccordionItem = ({ icon, title, extraInfo, badge, className, children, to }) => {

   const [isOpen, setIsOpen] = useState(false)
   const history = useHistory();

   return (
      <div className={
         classNames("accordion-item", className, {
            "accordion-item--link": to
         })
      } onClick={() => to && history.push(to)}>
         <div className="accordion-item__container">
            {!isEmpty(icon) && <span className="accordion-item__icon"><Icon size="xlg" src={icon} /></span>}
            <span
               className={
                  classNames("accordion-item__title", {
                     "accordion-item__title--hoverable": children
                  })
               }
               onClick={() => children && setIsOpen(!isOpen)}
            >{title}</span>
            <span className="accordion-item__info">{extraInfo}</span>
            {badge != null && badge != undefined && badge > 0 && <span className="accordion-item__badge">{badge}</span>}
            <span className={classNames("accordion-item__collapse-icon", {
               "accordion-item__collapse-icon--rotate": isOpen
            })} onClick={() => children && setIsOpen(!isOpen)}>&rsaquo;</span>
         </div>
         {children && <Collapse isOpen={isOpen} className="accordion-item__detail">
            {children}
         </Collapse>}
      </div>
   )
}

export default AccordionItem
